import React from 'react';
import Problem from './news_box/Problem';

class MojeNoweSprawy extends React.Component {
    render() {
        const {problem_list,limit, showMore, active, update, problems_count, active_id, option, setActiveId} = this.props
        const problem_list_content = Object.values(problem_list)[0];
        const {results} = problem_list_content || ''
        let problems = [];
        if(results) {
        results.map((item, i) => {
            problems.push(
                <Problem 
                    city={item.closest_city}
                    limit={limit}
                    showMore={showMore}
                    problem_content={item.problem_content}
                    id={item.id}
                    category={item.category}
                    date={item.sent_at_timestamp}
                    key={i}   
                    if_read={item.was_read_by_lawyer}
                    valuation={item.problem_valuation}
                    url={item.lawyer_chat_url}
                    active={active}
                    problem_list={problem_list}
                    index={i}
                    update={update}
                    active_id={active_id}
                    option={option}
                    setActiveId={setActiveId}
                />
            )
            return problems
        })
    }
        return(
            <div className="problems">
                {problems}
                <ShowMore showMore={showMore} results={results} problems_count={problems_count}/>
            </div>
        )
    }
}

class ShowMore extends React.Component {
    render() {
        const {showMore, results, problems_count} = this.props
        if (results && results.length >= 10 && results.length < problems_count) {
        return(
            <div className="top-buffer-lg text-center">
                <button className="btn btn-primary show-more" onClick={showMore}>
                    Pokaż więcej
                </button>
            </div>
        )
        }
    }
}

export default MojeNoweSprawy;